
import React from 'react';
import GrammarPageLayout from '../components/grammar-page-layout';
import GrammarExplanation from './passive-reporting-explanation';
const mainimage = '/Images/reportedspeech1.webp';

const sections = [
  { label: "Grammar", description: "Do this exercise to practice grammar.", type: "quiz", subtype: "passivereporting" },
];


const PassiveReporting = () => (
  <GrammarPageLayout
    level="B2"
    title="Passive Reporting Verbs"
    image={mainimage}
    ExplanationComponent={GrammarExplanation}
    sections={sections}
    seoTitle="Free English Passive Reporting Exercises"
    seoDescription="Report general beliefs, traditions and expectations with passive reporting verbs and 'be supposed to'. B2 level exercises."
    relatedCategory="grammar-exercises"
    relatedLevel="B2"
  />
);

export default PassiveReporting;
